import { WorkspaceDocumentType } from "@/models/workspace/Workspace";
import { cn as _cn } from "@capacit-com/lara-law-shared-ui";

import PDFIcon from "@/assets/file-icons/PDF.svg";
import XLSIcon from "@/assets/file-icons/XLS.svg";
import DOCXIcon from "@/assets/file-icons/DOCX.svg";
import PPTIcon from "@/assets/file-icons/PPT.svg";
import FolderIcon from "@/assets/file-icons/folder.svg";
import OtherIcon from "@/assets/file-icons/other.svg";

export const cn = _cn;

export function formatBytes(bytes: number, decimals = 0) {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return (
    Number.parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  );
}

export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString("da-DK", {
    weekday: "short",
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const getFileTypeIconSrc = (type: string | undefined) => {
  switch (type) {
    case "folder":
      return FolderIcon;
    case WorkspaceDocumentType.PDF:
      return PDFIcon;
    case WorkspaceDocumentType.XLSX:
    case WorkspaceDocumentType.XLS:
    case WorkspaceDocumentType.XLSM:
      return XLSIcon;
    case WorkspaceDocumentType.DOCX:
    case WorkspaceDocumentType.DOC:
      return DOCXIcon;
    case WorkspaceDocumentType.PPTX:
    case WorkspaceDocumentType.PPT:
      return PPTIcon;
    case WorkspaceDocumentType.TXT:
    case WorkspaceDocumentType.MD:
    case WorkspaceDocumentType.OTHER:
      return OtherIcon;
    default:
      // Return OtherIcon as fallback for undefined or unknown types
      return OtherIcon;
  }
};

/**
 * Converts a snake_case string to camelCase
 */
const snakeToCamel = (str: string): string => {
  return str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
};

/**
 * Recursively converts all snake_case keys in an object to camelCase
 */
export const convertKeysToCamelCase = <T>(obj: unknown): T => {
  if (obj === null || obj === undefined) {
    return obj as T;
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => convertKeysToCamelCase(item)) as T;
  }

  if (typeof obj === "object" && obj.constructor === Object) {
    return Object.keys(obj).reduce(
      (acc, key) => {
        const camelKey = snakeToCamel(key);
        acc[camelKey] = convertKeysToCamelCase(
          (obj as Record<string, unknown>)[key]
        );
        return acc;
      },
      {} as Record<string, unknown>
    ) as T;
  }

  return obj as T;
};
